import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { isInvestor } from '../../global/authentication/authentication-manager.js'

export default function FilterHeader(props) {
  const {
    title,
    placeholder,
    count,
    mode,
    defaultSearchText,
    isOpen,
    onClick,
    onSearch,
    onClearSearch,
    pushSearchInline,
    noAutoComplete,
  } = props

  const [searchText, setSearchText] = useState('')
  const [autoCompleteData, setAutoCompleteData] = useState([])
  const [autoCompleteActive, setAutoCompleteActive] = useState(false)
  const [autoCompleteIndex, setAutoCompleteIndex] = useState(-1)
  const [isFilterOpen, setIsFilterOpen] = useState(false)

  useEffect(() => {
    if (defaultSearchText) {
      setSearchText(defaultSearchText)
    }
  }, [defaultSearchText])

  useEffect(() => {
    if (isOpen) {
      setIsFilterOpen(true)
    } else {
      setIsFilterOpen(false)
    }
  }, [isOpen])

  useEffect(() => {
    const source = Axios.CancelToken.source()

    const siteParams = {
      investor: { site: 'cti-inv', count: '5' },
      advisor: { site: 'cti-adv', count: '5' },
    }

    const queryParams = isInvestor() ? siteParams.investor : siteParams.advisor

    const getSearchSuggestions = async () => {
      try {
        if (searchText.trim().length > 2 && searchText.split(' ').length < 2) {
          const url = `/api/${queryParams.site}/autocomplete/${searchText}?count=${queryParams.count}&field=text`

          const response = await Axios.get(url, {
            cancelToken: source.token,
          })

          setAutoCompleteData(response.data)
        } else {
          setAutoCompleteData([])
          setAutoCompleteActive(false)
        }
      } catch (error) {
        if (Axios.isCancel(error)) {
          return
        } else {
          throw error
        }
      }
    }

    if (defaultSearchText !== searchText && !noAutoComplete) {
      getSearchSuggestions()
    }

    setAutoCompleteActive(true)

    return () => {
      source.cancel()
    }
  }, [searchText])

  const onChangeSearch = (event) => {
    setSearchText(event.currentTarget.value)

    if (!mode || mode.indexOf('on-key-press') >= 0) {
      onSearch && onSearch(event)
    }
  }

  const onKeyUpSearch = (event) => {
    // UP ARROW
    if (event.keyCode === 38) {
      if (autoCompleteIndex === 0) {
        return
      }

      setAutoCompleteIndex(autoCompleteIndex - 1)
    }
    // DOWN ARROW
    else if (event.keyCode === 40) {
      if (autoCompleteIndex + 1 === autoCompleteData.length) {
        return
      }

      setAutoCompleteIndex(autoCompleteIndex + 1)
    }
    // ENTER
    else if (
      mode &&
      mode.indexOf('on-key-enter') >= 0 &&
      event.keyCode === 13
    ) {
      setAutoCompleteActive(false)

      if (searchText.length > 2 && autoCompleteData.length > 0) {
        setAutoCompleteIndex(-1)
        setAutoCompleteData([])

        const e = {
          currentTarget: {
            value:
              autoCompleteData[autoCompleteIndex] || event.currentTarget.value,
          },
        }

        onSearch && onSearch(e)
      } else {
        onSearch && onSearch(event)
      }
    }
  }

  const onClickAutoCompItem = (item) => {
    setAutoCompleteIndex(-1)
    setAutoCompleteData([])

    const event = {
      currentTarget: {
        value: item,
      },
    }

    onSearch && onSearch(event)
  }

  const onClickToggleFilter = (event) => {
    setIsFilterOpen(!isFilterOpen)

    onClick && onClick(event)
  }

  const onClickSearch = () => {
    setAutoCompleteIndex(-1)
    setAutoCompleteData([])

    const event = {
      currentTarget: {
        value: searchText,
      },
    }

    onSearch && onSearch(event)
  }

  const onClickClearSearch = (event) => {
    setSearchText('')
    setAutoCompleteIndex(-1)
    setAutoCompleteData([])

    onClearSearch && onClearSearch(event)
  }

  return (
    <>
      <div
        className={`u-flex u-sm-flexColReverse u-flexAlignItemsCenter u-sm-flexAlignItemsStretch ${
          pushSearchInline ? 'u-flexAuto' : ''
        }`}
      >
        {onClick && (
          <button
            className="Button Button-filter u-posRelative u-flex u-flexAlignItemsCenter u-flexAuto u-md-size1of2 u-lg-size1of2 u-paddingVert1gu u-sm-paddingVert3gu u-paddingHoriz4gu u-textLeft u-zIndexTier2"
            onClick={onClickToggleFilter}
            data-analytics="simple-entry-component-body-filter-dropdown-btn"
            data-qa-automation={'filter-dropdown-btn'}
          >
            <span className="u-textSizeMsrp5 MutualFunds-filterButton arrow Icon--material u-textSizeMsrp2">
              {isFilterOpen ? 'expand_less' : 'expand_more'}
            </span>
            <h2 className="u-textSizeMsrp1 u-paddingLeft3gu u-textBold u-textColorBrandDark">
              {title || 'Filters'}
            </h2>
            <div
              className="u-textSizeMsrp1 u-marginLeft2gu"
              data-qa-automation={'filter-applied-count'}
            >
              ({count} applied)
            </div>
          </button>
        )}
        <div
          className={
            'u-flex u-flexAlignItemsCenter u-flexAuto u-md-size1of2 u-lg-size1of2 u-bgColorWhite' +
            (onClick ? ' u-paddingLeft4gu u-sm-paddingLeft0' : '') +
            (mode && mode.indexOf('large-icon') >= 0
              ? ' u-paddingHoriz4gu u-paddingVert1gu'
              : '')
          }
        >
          <div
            className={`u-posRelative u-flexAuto ${
              mode && mode.indexOf('product-landing') >= 0
                ? ''
                : 'u-paddingBottom2gu'
            }`}
          >
            <span
              className={`Icon--material input-search-icon u-posAbsolute Icon--filter-search ${
                mode && mode.indexOf('large-icon') >= 0
                  ? 'u-sm-textSizeMsrp2 u-md-textSizeMsrp3 u-lg-textSizeMsrp4 '
                  : ''
              }${
                mode && mode.indexOf('large-icon') >= 0
                  ? 'large-icon-search-filter'
                  : mode && mode.indexOf('product-landing') >= 0
                    ? 'product-landing-search-filter'
                    : 'base-search-filter'
              }`}
              aria-hidden="true"
            >
              &#xE8B6;
            </span>
            <input
              type="text"
              placeholder={placeholder}
              className={
                'Input Input--withIcon Icon--before MutualFunds-searchField u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0' +
                (mode && mode.indexOf('large-icon') >= 0
                  ? ' u-sm-textSizeMsrp2 u-md-textSizeMsrp3 u-lg-textSizeMsrp4'
                  : '')
              }
              value={searchText}
              onChange={onChangeSearch}
              onKeyUp={onKeyUpSearch}
              data-qa-automation={'search-input-field'}
            />
            {onClearSearch && (
              <div
                id={'clearSearch'}
                className="u-posAbsolute u-padding2gu"
                style={{ cursor: 'pointer', top: '10%', right: 0 }}
                onClick={onClickClearSearch}
                data-qa-automation={'search-clear-btn'}
              >
                <span
                  id="cti-navigation-search-clear"
                  className={
                    'Icon--material input-close-icon' +
                    (mode && mode.indexOf('large-icon') >= 0
                      ? ' u-sm-textSizeMsrp2 u-md-textSizeMsrp3 u-lg-textSizeMsrp4'
                      : '')
                  }
                  aria-hidden="true"
                >
                  &#xE5CD;
                </span>
              </div>
            )}
          </div>
          {mode && mode.indexOf('submit-button') >= 0 && (
            <div>
              <input
                type="submit"
                className="Button Button--secondary u-textNoWrap u-marginLeft3gu"
                value="Search"
                onClick={onClickSearch}
                data-qa-automation="search-button"
              />
            </div>
          )}
        </div>
      </div>
      {autoCompleteData &&
        autoCompleteActive &&
        autoCompleteData.length > 0 && (
          <div className="dropdown u-bgColorWhite u-sizeConstrained">
            {autoCompleteData.map((item, index) => {
              return (
                <div
                  key={item}
                  data-qa-automation={`search-complete-suggestion${index}`}
                  className={`auto-complete-suggestion u-paddingVert1gu u-paddingLeft8gu u-size1of2 u-textSizeMsrp2 ${
                    index === autoCompleteIndex
                      ? 'u-bgColorBrandLight u-textColorWhite'
                      : ''
                  }`}
                  onClick={() => onClickAutoCompItem(item)}
                >
                  {item}
                </div>
              )
            })}
          </div>
        )}
    </>
  )
}
